export const searchTypeEnum = [
    { name: "渠道商名称", value: 1 },
    { name: "渠道编号", value: 2 },
]
